import React, { useEffect, useState } from 'react'
import { Link } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/core/styles'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined'
import isEmpty from 'lodash/isEmpty'
import { FUNDING, PayPalButtons } from '@paypal/react-paypal-js'
import CircularProgress from '@material-ui/core/CircularProgress'

const useStyles = makeStyles((theme) => ({
    placeOrderContainer: {
        [theme.breakpoints.up('sm')]: {
            padding: '10px 16px',
        },
        [theme.breakpoints.up('md')]: {
            padding: '10px 16px',
            display: 'flex',
            flexDirection: 'column',
            maxWidth:555
        },
        [theme.breakpoints.up('lg')]: {
            padding: '10px 17px',
        },
        [theme.breakpoints.up('xs')]: {
            padding: '10px 0',
        },
    },
    lockIcon: {
        fontSize: '1.3rem !important',
    },
    placeOrderButton: {
        marginBottom: '1rem'
    },
    payPalButton: {
        display: 'block',
        marginBottom: '0.75rem',
    },
    termsTextContainer: {
        fontSize: '0.75rem',
    },
    circularProgress: {
        marginRight: 10
    },
    greenBtn: {
        color: theme.palette.primary.main,
        borderColor: theme.palette.secondary.main,
        '&:hover': {
            borderColor: theme.palette.secondary.main,
        }    
    },
    roundedBtn: {
        borderRadius: 50,
        borderWidth: 3,
        '&:hover': {
            borderRadius: 50,
            borderWidth: 3
        },
        '& span': {
            textTransform: 'none',
            fontWeight: 'bold'
        }
    },
}))

const ConsumerCheckoutPlaceOrder = (props) => {
    const {
        diagnosticInfo,
        type,
        baseUrl,
        processing,
        checkingPhone,
        errors,
        disableSubmit,
        placeOrderButtonText,
        onSubmit,
        isPaypalCheckout,
        handlePaypalOnClick,
        handlePaypalCreateOrder,
        handlePaypalOnApprove,
        handlePaypalOnError,
        handlePaypalOnCancel,
        billingDetails,
        errorPhone
    } = props
    const classes = useStyles()
    const cartMerchantsWithTerms = window.React.cartMerchantsWithTerms
        ? JSON.parse(window.React.cartMerchantsWithTerms)
        : {}
    const hasPromotionTerms = !!window.React.hasPromotionTerms
    const hasVisaContent = !!window.React.hasVisaContent
    const hasMastercardContent = !!window.React.hasMastercardContent

    const [paypalButtonRefresher, setPaypalButtonRefresher] = useState(true);

    useEffect(()=>{
        // Hack part one. This is a hack to re-render the PayPalButtons component
        // every time billingDetailsChanges. The createOrder function
        // gets cached at the time of render, so this is the only way
        // we've found to accomplish having the phone number in the handlePaypalCreateOrder function. 
        setPaypalButtonRefresher(false);
    },
    [billingDetails])

    useEffect(()=>{
        // Hack part two. paypalButtonRefresher must be toggled back to true
        // in a separate useEffect.
        setPaypalButtonRefresher(true);
    }, [paypalButtonRefresher])

    const handleButtonClick = (event) => {
        console.log("cb92024a Submit button clicked:", new Date().toISOString());
        console.log("cb92024a Diagnostic Info:", diagnosticInfo);
        console.log("cb92024a Processing:", processing);
        console.log("cb92024a Checking Phone:", checkingPhone);
        console.log("cb92024a Error:", errors);
        console.log("cb92024a Place Order Button Text:", placeOrderButtonText);
        console.log("cb92024a Error Phone:", errorPhone);
        // Add any additional diagnostics here

        // Call the actual onSubmit function
        if (onSubmit) {
            onSubmit(event);
        }
    }

    return (
        <div className={classes.placeOrderContainer}>
            {isPaypalCheckout ? (
                <></>
            ) : (
                <SubmitButton
                    type={type}
                    processing={processing}
                    checkingPhone={checkingPhone}
                    error={errors && errors.length > 0}
                    label={placeOrderButtonText}
                    onClick={handleButtonClick}
                    errorPhone={errorPhone}
                />
            )}

            <Typography className={classes.termsTextContainer}>
                By placing an order, you agree to Gift Card Granny’s{' '}
                <Link href={`${baseUrl}/terms-cart/`} target="_blank">
                    Terms of Service
                </Link>
                {hasPromotionTerms && (
                    <>
                        {' '}
                        and acknowledge the applicable restrictions of any
                        promotional offers
                    </>
                )}
                {hasVisaContent && (
                    <>
                        , our{' '}
                        <Link
                            href={`${baseUrl}/cardholder-agreement/gcg-qlo-visa/`}
                            target="_blank"
                        >
                            Visa Gift Card Terms and Conditions
                        </Link>
                        , and{' '}
                        <Link
                            href={`${baseUrl}/visa-gift-card/fees/`}
                            target="_blank"
                        >
                            Visa Gift Card Fee Schedule
                        </Link>
                    </>
                )}
                {hasMastercardContent && (
                    <>
                        , our{' '}
                        <Link
                            href={`${baseUrl}/cardholder-agreement/gcg-qlo-mc/`}
                            target="_blank"
                        >
                            Mastercard Gift Card Terms and Conditions
                        </Link>
                        , and{' '}
                        <Link
                            href={`${baseUrl}/mastercard-gift-card/fees/`}
                            target="_blank"
                        >
                            Mastercard Gift Card Fee Schedule
                        </Link>
                    </>
                )}
                {!isEmpty(cartMerchantsWithTerms) && (
                    <>
                        {' '}
                        and any Terms & Conditions of Use for applicable branded
                        gift cards:{' '}
                        {cartMerchantsWithTerms.map(
                            (cartMerchantWithTerms, index) => (
                                <React.Fragment
                                    key={cartMerchantWithTerms.slug}
                                >
                                    {' '}
                                    <Link
                                        href={`${baseUrl}/terms/${cartMerchantWithTerms.slug}/`}
                                        target="_blank"
                                    >
                                        {cartMerchantWithTerms.name}
                                        {index !==
                                            cartMerchantsWithTerms.length - 1 &&
                                            ','}
                                    </Link>
                                </React.Fragment>
                            )
                        )}
                    </>
                )}
                .
            </Typography>
        </div>
    )
}

const SubmitButton = ({
    type,
    processing,
    error,
    label,
    disabled,
    onClick,
    checkingPhone,
    errorPhone
}) => {
    const classes = useStyles()

    const getButtonText = () => {
        if(processing) {
            return <><CircularProgress className={classes.circularProgress} />Processing...</>
        }
        if (checkingPhone) {
            return <><CircularProgress className={classes.circularProgress} />Checking Phone Status...</>
        }
        if (errorPhone) {
            return 'Please check the phone number field!'
        }
        return label
    }

    return (<>
        
        <Button
            id="place-order-button"
            variant="outlined"
            fullWidth
            size="large"
            startIcon={(processing || checkingPhone) ? '' : <LockOutlinedIcon className={classes.lockIcon} />}
            disabled={processing || checkingPhone || disabled}
            className={`${error ? 'button--error' : ''} ${classes.greenBtn} ${classes.roundedBtn} ${classes.placeOrderButton}`}
            onClick={onClick ? onClick : undefined}
            data-testid="place-order-button"
            type={type ? type : 'button'}
        >
            {
                getButtonText()
            }
        </Button>
        </>
    )
}

export default ConsumerCheckoutPlaceOrder
